import { FormInputProps } from 'brief-form'

import { BaseInputOpts } from '../props'

type InputGroupOpts = BaseInputOpts & {
  buttonText: string
}

export interface InputGroupProps extends FormInputProps<string, InputGroupOpts> {}
